import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call, put } from 'redux-saga/effects';
import { startLoading, finishLoading } from '../loading';
import * as targetApi from '../../lib/api/target';

// ==================== 액션 타입 ====================

// 사용자별 목표 조회
const GET_USER_TARGET = 'target/GET_USER_TARGET';
const GET_USER_TARGET_SUCCESS = 'target/GET_USER_TARGET_SUCCESS';
const GET_USER_TARGET_FAILURE = 'target/GET_USER_TARGET_FAILURE';

// 목표 상태 설정
const SET_USER_TARGET = 'target/SET_USER_TARGET';

// 목표 초기화
const RESET_USER_TARGET = 'target/RESET_USER_TARGET';

// ==================== 액션 생성자 ====================

export const getUserTarget = createAction(
  GET_USER_TARGET, 
  ({ targetTyp, usrUuid, targetYear }) => ({ targetTyp, usrUuid, targetYear })
);
export const setUserTarget = createAction(SET_USER_TARGET, (data) => data);
export const resetUserTarget = createAction(RESET_USER_TARGET);

// ==================== 사가 ====================

function* getUserTargetSaga(action) {
  const { targetTyp, usrUuid, targetYear } = action.payload;
  yield put(startLoading(GET_USER_TARGET));
  
  try {
    const response = yield call(targetApi.getTargetByUser, targetTyp, usrUuid, targetYear);
    yield put({
      type: GET_USER_TARGET_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USER_TARGET_FAILURE,
      payload: error,
      error: true,
    });
  }
  
  yield put(finishLoading(GET_USER_TARGET));
}

export function* userTargetSaga() {
  yield takeLatest(GET_USER_TARGET, getUserTargetSaga);
}

// ==================== 초기 상태 ====================

const initialState = {
  userTarget: null,
  error: null,
};

// ==================== 리듀서 ====================

const userTarget = handleActions(
  {
    [GET_USER_TARGET_SUCCESS]: (state, { payload: response }) => ({
      ...state,
      userTarget: response.data || null,
      error: null,
    }),
    [GET_USER_TARGET_FAILURE]: (state, { payload: error }) => ({
      ...state,
      userTarget: null,
      error,
    }),
    [SET_USER_TARGET]: (state, { payload: data }) => ({
      ...state,
      userTarget: data,
    }),
    [RESET_USER_TARGET]: () => initialState,
  },
  initialState,
);

export default userTarget;
